import { render, staticRenderFns } from "./textualResearchClassification.vue?vue&type=template&id=4c40b929"
import script from "./textualResearchClassification.vue?vue&type=script&lang=js"
export * from "./textualResearchClassification.vue?vue&type=script&lang=js"
import style0 from "./textualResearchClassification.vue?vue&type=style&index=0&id=4c40b929&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports